module.exports = __webpack_public_path__ + "img/logo.d5c2770d.png";